import { Controller } from "stimulus"
import React from 'react';
import { render } from 'react-dom';
import FlashNotice from "../src/ui/FlashNotice";

export default class extends Controller {
  static values = {
    text: String
  };

  connect() {
    const container = document.getElementById('flash-notice-container');
    const { textValue } = this;

    render(<FlashNotice notice={textValue} />, container);
  }
}



// WEBPACK FOOTER //
// ./app/javascript/controllers/flash_notice_controller.js